import { useContext } from "react";
import FormType, { FieldConfigs } from "../../../../../shared/components/FormType";
import { Product } from "../../../../../data/entities";
import { ROLE } from "../../../../../data/enums";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { api } from "../../../../../shared/hooks/api";

interface FormContainerProps {
    validated: boolean;
    productData?: Product;
    mergeProduct: Function;
    onSubmit?: Function;
}

const FormContainer = ({
                           validated,
                           productData,
                           mergeProduct,
                           onSubmit,
                       }: FormContainerProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const [{ data: categoryData }] = api.get("/products/category-groups/", { page: 1, page_size: 1000 });

    const fields: FieldConfigs[] = [
        { label: "Trạng thái sản phẩm", type: "toggle", key: "is_active" },
        {
            label: "Mã sản phẩm",
            type: "text",
            key: "product_code",
            required: true,
        },
        { label: "Tên sản phẩm", type: "text", key: "name", required: true },
        {
            label: "Danh mục",
            type: "dropdown",
            key: "category",
            options: [
                { text: "Phuy", value: "Phuy" },
                { text: "Thùng", value: "Thùng" },
                { text: "Cơ Khí Ô Tô", value: "Cơ Khí Ô Tô" },
            ],
            required: true,
        },
        {
            label: "Nhóm sản phẩm",
            type: "autocomplete",
            key: "category_group",
            required: true,
            placeholder: "Chọn nhóm sản phẩm",
            options: categoryData?.results?.map((category: any) => ({
                name: category.name,
                id: category.id,
            })),
            getOptionValue: (option: any) => option.id,
            getOptionLabel: (option: any) => option.name,
            noDataText: "Không tìm thấy nhà cung cấp",
        },
        {
            label: "Kho số",
            type: "dropdown",
            key: "storage",
            options: [
                { text: "Kho 1", value: "Kho 1" },
                { text: "Kho 2", value: "Kho 2" },
            ],
            required: true,
        },
        {
            label: "Số lượng",
            type: "text",
            key: "quantity",
        },
        {
            label: "Ghi chú",
            type: "text",
            key: "note",
        },
    ];

    const getFields = () => {
        switch (role) {
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
                return fields
                    .filter(
                        (item) => item.key !== "base_price",
                    )
                    .map((item) => ({
                        ...item,
                        disabled: true,
                    }));
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.DELIVERER:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.FACTORY_STAFF:
                return fields.map((item) => ({
                    ...item,
                    disabled: true,
                }));
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return fields;
        }
    };

    return (
        <FormType
            title={"Thông Tin Sản Phẩm"}
            fields={getFields()}
            validated={validated}
            requireData={productData}
            mergeFormData={mergeProduct}
        />
    );
};

export default FormContainer;
